module.exports = __webpack_public_path__ + "img/img29.232e4950.jpg";